module.exports = __webpack_public_path__ + "static/bed-nav-cf6f56c489b32189e2ee4351a9e89f83.jpeg";